export enum AppUserType {
	CANDIDATE = 'Candidate',
	WEB_USER = 'Sponsor Portal Web User',
}
